<script lang="ts">
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import type { OrderMessage, ViewerContext } from "@shared/types/OrderMessage";
  import Flash from "@shared/services/flashv2.js";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import MessagesStore from "../../../Stores/OrderMessagesStore";
  import MessagesViewerStore from "../../../Stores/OrderMessagesViewerStore";
  import { onDestroy, getContext } from "svelte";

  export let orderId: number;
  export let messageThreadId: number;
  let token: string;
  let repId: string;
  token = getContext("token");
  repId = getContext("repId");
  let viewerContext: ViewerContext;
  let messageContent = "";

  const messagesViewerUnsubscribe = MessagesViewerStore.subscribe((viewer: ViewerContext) => {
    viewerContext = viewer;
  });
  onDestroy(messagesViewerUnsubscribe);

  $: sendButtonDisabled = messageContent.trim() === "";
  $: iconColor = sendButtonDisabled ? "#A8DCEE" : "#008FBE";

  const sendMessage = async () => {
    try {
      await HttpPromise({
        method: "PUT",
        url:
          `api/orders/${orderId}/message_threads/${messageThreadId}` +
          (token ? `?token=${token}` : "") +
          (repId ? `&rep_id=${repId}` : ""),
        data: { message: { content: messageContent } },
      });
      MessagesStore.update((messages: OrderMessage[]) => {
        return [
          ...messages,
          {
            content: messageContent,
            created_at: new Date(),
            sender: viewerContext,
          },
        ];
      });
      messageContent = "";
    } catch (err) {
      Flash.now({
        type: "error",
        message: "There was a problem sending the message",
      });
    }
  };

</script>

<style>
  .inline-icon {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .inline-icon:disabled {
    cursor: default;
  }
  .inline-icon:disabled:hover {
    background-color: inherit;
  }

  .input_padding {
    padding: 0.5rem 0rem 0.5rem 1rem !important;
  }

</style>

<form on:submit|preventDefault={sendMessage}>
  <div class="fizz-relative fizz-inline-block fizz-full-width">
    <div class="fizz-input-text fizz-input-with-button">
      <input
        type="text"
        placeholder="Send a message"
        data-testid="order-detail-message-input"
        class="input_padding message_content"
        bind:value={messageContent}
      />
    </div>
    <button
      class="fizz-icon-button-small inline-icon"
      data-testid="order-detail-send-message"
      disabled={sendButtonDisabled}
    >
      <Icon type="MessageArrow" height="20" width="20" color={iconColor} />
    </button>
  </div>
</form>
